import { lazy } from '@loadable/component';
import { createFileRoute } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

const MailTemplateEditorEdit = lazy(async () =>
    import(/* webpackChunkName: "MailTemplateEditorEdit" */ '@mews-commander/email-template-editor').then((module) => ({
        default: module.MailTemplateEditorEdit,
    }))
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/MailTemplateEditor/Edit/$id')({
    component: Component,
    staticData: {
        owner: MewsTeam.GuestExperience,
        type: RouteType.Frontend,
        title: TextKey.MailTemplatePageTitleUpdate,
    },
});

function Component() {
    const { id } = Route.useParams();

    return <MailTemplateEditorEdit templateId={id} />;
}
